import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const UserIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10 3.33334C9.11594 3.33334 8.2681 3.68453 7.64298 4.30965C7.01786 4.93478 6.66667 5.78262 6.66667 6.66668C6.66667 7.55073 7.01786 8.39858 7.64298 9.0237C8.2681 9.64882 9.11594 10 10 10C10.8841 10 11.7319 9.64882 12.357 9.0237C12.9821 8.39858 13.3333 7.55073 13.3333 6.66668C13.3333 5.78262 12.9821 4.93478 12.357 4.30965C11.7319 3.68453 10.8841 3.33334 10 3.33334ZM7.34212 11.5772C4.99462 12.0972 2.5 13.2375 2.5 15V17.0833H17.5V15C17.5 13.2375 15.0054 12.0972 12.6579 11.5772C12.0495 12.3863 11.09 12.9167 10 12.9167C8.91 12.9167 7.95046 12.3863 7.34212 11.5772Z",
      fill: "#757575"
    }
  ) }),
  "User"
);
export {
  UserIcon
};
